import React from 'react';
import { Notification, toast } from '@m12s/component-library';
import { PreWrap, FullWrap } from './styled';

const DEFAULT_DURATION = 3000;

const throwErrorToast = (message, opts = {}) => {
  const autoClose = opts?.autoClose || DEFAULT_DURATION;
  return toast(
    <Notification text={<PreWrap>{message}</PreWrap>} status="error" />,
    {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose,
      ...opts,
      className: 'mm-notification-toast error',
      ariaLabel: message,
    }
  );
};

const throwSuccessToast = (message, opts = {}) => {
  const autoClose = opts?.autoClose || DEFAULT_DURATION;
  return toast(
    <Notification text={<PreWrap>{message}</PreWrap>} status="success" />,
    {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose,
      ...opts,
      className: 'mm-notification-toast success',
      ariaLabel: message,
    }
  );
};

const throwStatusToast = (message, status, opts = {}) => {
  const autoClose = opts?.autoClose || DEFAULT_DURATION;

  return toast(
    <Notification text={<PreWrap>{message}</PreWrap>} status={status} />,
    {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose,
      ...opts,
      className: `mm-notification-toast ${status}`,
      ariaLabel: message,
    }
  );
};

// Non-blocking, operator-readable warning (e.g. ERP BPM InfoMessages). Long
// autoClose like critical errors — warnings carry instructions worth reading —
// but orange and never tied to a failed submission.
const throwWarningToast = (message, opts = {}) => {
  return toast(
    <Notification text={<FullWrap>{message}</FullWrap>} status="warning" />,
    {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 15000,
      closeOnClick: true,
      ...opts,
      className: 'mm-notification-toast warning',
      ariaLabel: message,
    }
  );
};

// Toasts each non-fatal ERP warning on a submit-NATS response. `warnings` is a
// top-level string array, absent when the ERP raised none.
const throwWarningToasts = (warnings) => {
  if (Array.isArray(warnings)) {
    warnings.forEach((warning) => {
      return throwWarningToast(warning);
    });
  }
};

const throwCriticalErrorToast = (message, opts = {}) => {
  return toast(
    <Notification text={<FullWrap>{message}</FullWrap>} status="error" />,
    {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 15000,
      closeOnClick: true,
      ...opts,
      className: 'mm-notification-toast critical-error',
      ariaLabel: message,
    }
  );
};

export {
  throwErrorToast,
  throwSuccessToast,
  throwStatusToast,
  throwWarningToast,
  throwWarningToasts,
  throwCriticalErrorToast,
};
